import React from 'react';
import {
	Alert,
	Card,
	CardBody,
	CardHeader,
	Col,
	Row,
} from 'reactstrap';
import {processMessage} from '../helpers/websocket.helper.js';
import {duplicatesService} from '../services/duplicates.service';
import DuplicatesList from 'components/Duplicates/DuplicatesList';
import DuplicatesFilter from 'components/Duplicates/DuplicatesFilter';
import DuplicatesPager from 'components/Duplicates/DuplicatesPager';
const BASE_URL = process.env.REACT_APP_WS_URL;

class Duplicates extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			duplicates: [],
			filter: 'email',
			pager: 1,
			alertMessage: 'Loading duplicate deals (can take minutes...)'
		};
	}

	componentDidMount() {
		this.connect();
	}

  componentWillUnmount() {
    if (this.ws) {
      this.willUnmount = true;
      this.ws.close();
    }
  }

	connect = () => {
		duplicatesService.getWebsocketTicket().then(({ticket}) => {
			this.ws = new WebSocket(BASE_URL + '/ws?ticket=' +
				encodeURIComponent(ticket));
			this.ws.onopen = () => {
				duplicatesService.getDuplicates().then(() => {
					this.setState({loading: true});
				});
			}
			this.ws.onmessage = event => {
				let data = processMessage(event);
				if (data.duplicates) {
					this.setState({
						loading: false,
						duplicates: data.duplicates});
				}
				else if (data.error) {
					this.setState({alertMessage: data.error});
				}
			}
			this.ws.onclose = () => {
				if (this.willUnmount) {
					return;
				}
				console.log('web socket disconnected. retrying connection...');
				setTimeout(this.connect, 5000);
			}
			this.ws.onerror = err => {
				console.error('web socket error: ', err.message);
				this.ws.close();
			}
		}).catch(() => {
			this.setState({alertMessage: 'Unable to authorize websocket connection'});
		});
	}

	updateFilter = (filter) => {
		this.setState({filter: filter});
	}

	updatePager = (pager) => {
		this.setState({pager: pager});
	}

	render() {
		const {loading,
					 duplicates,
					 filter,
					 pager,
					 alertMessage} = this.state;
		return (
			<div className="content">
				<Alert color="primary" isOpen={loading}>{alertMessage}</Alert>
				<Row>
					<Col>
						<Card>
							<CardHeader>
								<h4>Duplicate Deal Options</h4>
							</CardHeader>
							<CardBody>
								<Row>
									<Col>
										<DuplicatesFilter updateFilter={this.updateFilter}/>
									</Col>
									<Col>
										<DuplicatesPager duplicates={duplicates}
											filter={filter} updatePager={this.updatePager}/>
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col>
						<DuplicatesList
							duplicates={duplicates} filter={filter} pager={pager}/>
					</Col>
				</Row>
			</div>
		);
	}
}

export default Duplicates;
